export enum TypographySize {
	SMALL = 'small',
	MEDIUM = 'medium',
	LARGE = 'large',
}
